/**
 * Entry point for development and production PWA builds.
 */
import 'regenerator-runtime/runtime';
import { createRoot } from 'react-dom/client';
import App from './App';
import { cache } from '@cornerstonejs/core';
cache.setMaxCacheSize(3 * 1024 * 1024 * 1024); // increased to 3GB to handle large MPR series
import React from 'react';
import { history } from './utils/history';

/**
 * Suppress benign Cornerstone viewport destruction warnings that don't break functionality
 */
const originalError = console.error;
console.error = function(...args) {
  const msg = args[0]?.toString?.() || '';
  // Suppress destroyed viewport errors that happen during normal mode switching
  if (msg.includes('destroyed') && msg.includes('viewport')) {
    return;
  }
  originalError.apply(console, args);
};

// Suppress unhandled promise rejections from destroyed viewports
window.addEventListener('unhandledrejection', event => {
  const msg = event.reason?.toString?.() || '';
  if (msg.includes('destroyed') && msg.includes('viewport')) {
    event.preventDefault();
  }
});

/**
 * EXTENSIONS AND MODES
 * =================
 * pluginImports.js is dynamically generated from extension and mode
 * configuration at build time.
 *
 * pluginImports.js imports all of the modes and extensions and adds them
 * to the window for processing.
 */
import { modes as defaultModes, extensions as defaultExtensions } from './pluginImports';
import loadDynamicConfig from './loadDynamicConfig';

loadDynamicConfig(window.config).then(config_json => {
  // Reset Dynamic config if defined
  if (config_json !== null) {
    window.config = config_json;
  }

  /**
   * Combine our appConfiguration with installed extensions and modes.
   * In the future appConfiguration may contain modes added at runtime.
   *  */
  const appProps = {
    config: window ? window.config : {},
    defaultExtensions,
    defaultModes,
  };

  const container = document.getElementById('root');

  const root = createRoot(container);
  root.render(React.createElement(App, appProps));
});

export { history };
